/*
 *  (c) 2015 - 2022 ENISCO by FORCAM GmbH
 */

import {createSlice} from '@reduxjs/toolkit'
import {Config} from '../model/config'

export const initialState: Config = {
  registeredApps: [],
  registeredModules: [],
  registeredUserSettings: [],
  currentApp: undefined,
  myProfileOpen: false,
  profile: undefined,
  favoriteApps: [],
  favoriteGroups: [],
  favoriteApp: undefined,
  defaultParameters: [],
  search: ''
}

const appsSlice = createSlice({
  name: 'apps',
  initialState,
  reducers: {
    setCurrentApp: (state, {payload}) => {
      state.currentApp = payload
    },
    setRegisteredModules: (state, {payload}) => {
      state.registeredModules = payload
    },
    setRegisteredApps: (state, {payload}) => {
      state.registeredApps = payload
    },
    setRegisteredUserSettings: (state, {payload}) => {
      state.registeredUserSettings = payload
    },
    setMyProfileOpen: (state, {payload}) => {
      state.myProfileOpen = payload
    },
    setProfile: (state, {payload}) => {
      state.profile = payload
    },
    setFavoriteApps: (state, {payload}) => {
      state.favoriteApps = payload
    },
    setFavoriteGroups: (state, {payload}) => {
      state.favoriteGroups = payload
    },
    setFavoriteApp: (state, {payload}) => {
      state.favoriteApp = payload
    },
    setDefaultParameters: (state, {payload}) => {
      state.defaultParameters = payload
    },
    setSearch: (state, {payload}) => {
      state.search = payload
    }
  }
})

const {reducer, actions} = appsSlice

export const {
  setCurrentApp,
  setRegisteredApps,
  setRegisteredModules,
  setRegisteredUserSettings,
  setMyProfileOpen,
  setProfile,
  setFavoriteApps,
  setFavoriteGroups,
  setFavoriteApp,
  setDefaultParameters,
  setSearch
} = actions

export default reducer
